import { Observable } from "rxjs";
import HttpService from "./HttpService";
import { url } from "./APIEndPoints";
import {
  buildParamString,
  IAPIResponse,
} from "@mindmemobile/mm-shared-global";
import {
  IAPICreateSellerModel,
  IAPILinkedSellerModel,
  IAPISellerGrid,
} from "../interfaces/SellerInterfaces";

class SellerService {
  private httpService: HttpService;
  constructor() {
    this.httpService = new HttpService(
      undefined,
      `${process.env.REACT_APP_API_KEY}`,
      process.env.REACT_APP_API_BASE_URL
    );
  }

  getSeller(
    accountId: string,
    id: string
  ): Observable<IAPIResponse<IAPICreateSellerModel>> {
    const params: string = buildParamString({
      accountId: accountId,
      id: id,
    });
    return this.httpService.get<IAPIResponse<IAPICreateSellerModel>>(
      url.getSeller,
      params
    );
  }

  createSeller(
    data: IAPICreateSellerModel
  ): Observable<IAPIResponse<IAPICreateSellerModel>> {
    return this.httpService.post<IAPIResponse<IAPICreateSellerModel>>(
      url.createSeller,
      data
    );
  }

  updateSeller(
    data: IAPICreateSellerModel
  ): Observable<IAPIResponse<IAPICreateSellerModel>> {
    return this.httpService.post<IAPIResponse<IAPICreateSellerModel>>(
      url.updateSeller,
      data
    );
  }

  deleteSeller(accountId: string, id: string): Observable<IAPIResponse<any>> {
    const request = { accountId: accountId, Id: id };
    return this.httpService.put<IAPIResponse<any>>(url.deleteSeller, request);
  }

  getSellerNames(
    accountId: string
  ): Observable<IAPIResponse<IAPILinkedSellerModel[]>> {
    const params: string = buildParamString({
      accountId: accountId,
    });
    return this.httpService.get<IAPIResponse<IAPILinkedSellerModel[]>>(
      url.getSellerNames,
      params
    );
  }

  getSellersGridData(
    accountId: string,
    pageNumber: number,
    pageSize: string,
    searchValue: string
  ): Observable<IAPIResponse<IAPISellerGrid[]>> {
    const params: string = buildParamString({
      accountId,
      pageNumber,
      pageSize,
      searchValue,
    });
    return this.httpService.get<IAPIResponse<IAPISellerGrid[]>>(
      url.getSellers,
      params
    );
  }
}
export default new SellerService();
